import {Component, computed, effect, input, output, signal} from '@angular/core';
import {NgClass} from "@angular/common";
import {RadarSvgComponent} from "src/app/presentation/common/icons/radar-svg/radar-svg.component";
import {Animal} from "src/app/infrastructure/moovement-api/models/asset";
import {
  AnimalButtonComponent
} from "src/app/presentation/main-view/information-center/animals/animal-button/animal-button.component";
import {
  Observation
} from 'src/app/presentation/main-view/information-center/proximity-sample-points/proximity-sample-point-details/observation';

@Component({
  selector: 'app-observed-animals',
  imports: [
    NgClass,
    RadarSvgComponent,
    AnimalButtonComponent
],
  templateUrl: './observed-animals.component.html',
  styleUrl: './observed-animals.component.css'
})
export class ObservedAnimalsComponent {

  animals = input.required<Animal[]>();
  assignedAnimals = input.required<Set<Animal>>();
  lastObservationPerAnimalId = input.required<Map<string, Observation>>();
  name = input.required<string>();
  canClear = input(false);
  canRefresh = input(false);
  onlyAssigned = input<boolean>(false);

  onClear = output();
  onRefresh = output();

  totalCount = computed(() => this.animals().length);
  assignedAndObservedCount = signal(0);
  assignedCount = computed(() => this.assignedAnimals().size);
  notAssignedAndObservedCount = signal(0);

  open: boolean = false;

  constructor() {
    effect(() => {
      const observedAnimals = this.animals();
      const assignedAnimals = this.assignedAnimals();

      let assignedAndObservedCount = 0;
      let notAssignedAndObservedCount = 0;

      for (const animal of observedAnimals) {
        if (assignedAnimals && assignedAnimals.has(animal)) {
          assignedAndObservedCount++;
        } else {
          notAssignedAndObservedCount++;
        }
      }

      this.assignedAndObservedCount.set(assignedAndObservedCount);
      this.notAssignedAndObservedCount.set(notAssignedAndObservedCount);
    });
  }

  toggle() {
    this.open = !this.open
  }

  clear(event: PointerEvent) {
    event.stopPropagation();
    this.onClear.emit();
  }

  refresh(event: PointerEvent) {
    event.stopPropagation();
    this.onRefresh.emit();
  }
}
